const defaultStyles = {
  fontWeight: {
    yAxis: "500",
    xAxis: "500",
    navigator: "500",
  },
};

export const useGetMandatorStyles = () => defaultStyles;
